export const RSA_PACKAGES_ROUTE="/rsa-packages";